'use client'

import React from 'react'
import { Inter } from 'next/font/google'

const inter = Inter({
    subsets: ['vietnamese'],
    weight: ['600'],
    display: 'swap'
})

const TEXT_CONTENT = "KẾT NỐI HÀNH TRÌNH CHẠM ĐẾN TƯƠNG LAI - ROVI HOLDINGS -" + " "

const baseList = Array(10).fill(TEXT_CONTENT)
const MARQUEE_ITEMS = [baseList]

const SloganMarqueeSection = () => {
    return (
        <section className="pt-12 pb-0 bg-white overflow-hidden">
            <div className="relative w-full">

                <div className="overflow-hidden flex items-center">
                    <div className="flex animate-marquee-text whitespace-nowrap py-4">
                        {MARQUEE_ITEMS.map((text, index) => (
                            <div
                                key={index}
                                className="mx-4 md:mx-8 flex items-center justify-center"
                            >
                                <span

                                    className={`${inter.className} text-4xl md:text-6xl font-semibold uppercase tracking-wider opacity-20 transition-all duration-300 cursor-default select-none text-gray-400`}
                                    style={{
                                        letterSpacing: '0.03em',
                                        WebkitTextStroke: '1px rgba(156, 163, 175, 0.2)',
                                        WebkitFontSmoothing: 'antialiased',
                                        paddingTop: '0.25rem',
                                        paddingBottom: '0.25rem',
                                    }}
                                >
                                    {text}
                                </span>

                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <style jsx>{`
                @keyframes marquee-text {
                    from { transform: translateX(0); }
                    to { transform: translateX(-50%); }
                }
                .animate-marquee-text {
                    animation: marquee-text 30s linear infinite;
                    will-change: transform;
                }
                @media (min-width: 768px) {
                    .animate-marquee-text { animation-duration: 100s; }
                }
            
            `}</style>
        </section>
    )
}

export default SloganMarqueeSection